export default "__VITE_ASSET__C9VxM_hV__"